import { ActionType, createAsyncAction } from 'typesafe-actions'
import { ChatState } from '../../types'
import { Failure, Request, Success } from './types'

export const updateChatFirebaseAction = createAsyncAction(
  '@chat/UPDATE_CHAT_FIREBASE_NEW_CHAT_REQUEST',
  '@chat/UPDATE_CHAT_FIREBASE_NEW_CHAT_SUCCESS',
  '@chat/UPDATE_CHAT_FIREBASE_NEW_CHAT_FAILURE'
)<Request, Success, Failure>()

const request = (state: ChatState): ChatState => ({
  ...state,
  isLoadingUpdateChatFirebase: true,
  isErrorOnUpdateChatFirebase: false
})

const success = (state: ChatState, { payload }: ActionType<typeof updateChatFirebaseAction.success>): ChatState => {
  const activeChat = state?.activeChat

  let newActiveChat = null
  if (activeChat?.id === payload?.chatId) {
    newActiveChat = {
      ...activeChat,
      ...payload.updateChat
    }
  }

  switch (newActiveChat?.status) {
    case 'open':
      const currentChatIndex = state.openChats.findIndex(c => c.id === newActiveChat?.id)
      if (currentChatIndex > -1) {
        state.openChats[currentChatIndex] = {
          ...state.openChats[currentChatIndex],
          ...payload.updateChat
        }
      }

      break
    case 'in_progress':
      const inProgressChatIndex = state.inProgressChats.findIndex(c => c.id === newActiveChat?.id)
      if (inProgressChatIndex > -1) {
        state.inProgressChats[inProgressChatIndex] = {
          ...state.inProgressChats[inProgressChatIndex],
          ...payload.updateChat
        }
      }
      break
    case 'close':
      const finishedChatIndex = state.finishedChats.findIndex(c => c.id === newActiveChat?.id)
      if (finishedChatIndex > -1) {
        state.finishedChats[finishedChatIndex] = {
          ...state.finishedChats[finishedChatIndex],
          ...payload.updateChat
        }
      }
      break

    default:
      break
  }

  return {
    ...state,
    ...(newActiveChat && { activeChat: newActiveChat }),
    isLoadingUpdateChatFirebase: false,
    isErrorOnUpdateChatFirebase: false
  }
}

const failure = (state: ChatState): ChatState => ({
  ...state,
  isLoadingUpdateChatFirebase: false,
  isErrorOnUpdateChatFirebase: true
})

export const updateChatFirebaseHandle = { asyncAction: updateChatFirebaseAction, request, success, failure }
